export const TRUEMED_ORIGIN_URL = process.env.TRUEMED_BASE_URL ?? 'https://dev.truemed.com';